export function SectionHeader({ eyebrow, title, align = "left", className = "max-w-3xl" }) {
  return (
    <div className={`reveal ${className} ${align === "center" ? "mx-auto text-center" : ""}`}>
      <div className="eyebrow mb-4">{eyebrow}</div>
      <h2 className="font-display text-[clamp(2rem,4.5vw,3.75rem)] leading-[1.25] font-medium">
        {title}
      </h2>
    </div>
  );
}
